// js-buy-banner.js
;(({ $, $$ , log}) => {
    $$('.js-buy-banner').forEach(tool => {
        const previews = tool.querySelectorAll('.js-buy-banner__preview')
        const select = tool.querySelector('.js-buy-banner__type-select')
        
        init()
        
        function init() {

            select.addEventListener('change', event => {
                const { value } = event
                updatePreview(value)
            })

            updatePreview(select.querySelector('.ro-select__input').value)
        }

        function updatePreview(selectType) {
            previews.forEach(preview => {
                preview.querySelectorAll('.buy-banner-section__preview-section').forEach(section => {
                    const { type } = section.dataset
                    if (type === selectType) {
                        section.removeAttribute('style')
                    } else {
                        section.style.display = 'none'
                    }
                })
            })
        }
    })
})(CNS);